import { Component, Input } from '@angular/core';
import { IAntecedentes, ICertificado, IObra, IPeriodos, IReporteF301, ITrabajador } from 'src/app/models/direccion-trabajo/reporte-f301.model';
import { PdfGeneratorService } from 'src/app/shared/services/pdf-generator.service';
import { AlertService } from '../../_alert/alert.service';
import { goToTop } from 'src/app/shared/utils/utils';

@Component({
  selector: 'app-reporte-f301-viewer',
  templateUrl: './reporte-f301-viewer.component.html',
  styleUrls: ['./reporte-f301-viewer.component.scss']
})
export class ReporteF301ViewerComponent {
    @Input() content!: IReporteF301;
    @Input() showHeader = true;

    private idTransaccion!: string;
    public rut = '';
    public today = '';

    public antecedentes!: IAntecedentes;
    public obra!: IObra;
    public periodos!: IPeriodos;
    public certificado!: ICertificado;
    public trabajadoresDeclaradosDataSource!: ITrabajador[];

    public trabajadoresDeclaradosDisplayedColumns: string[] = [
        'rut',
        'nombre',
    ];

    isPDFLoading = false;
    PDF_REPORT_NAME = 'reporteF301';

    constructor(
        private pdfGeneratorService: PdfGeneratorService,
        private alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.setRut();
        this.setToday();

        const report = this.content.Reporte.report;

        this.antecedentes = report.antecedentes;
        this.obra = report.obra;
        this.periodos = report.periodos;
        this.certificado = report.certificado;
        this.trabajadoresDeclaradosDataSource = report.trabajadoresDeclarados;

        this.idTransaccion = this.content.DatosBasicosSolicitud.IDTransaccion;
    }

    setRut() {
        this.rut = this.content.DatosBasicosSolicitud.Rut + '-' + this.content.DatosBasicosSolicitud.DV
    }

    setToday() {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }

    getPDF() {
        this.isPDFLoading = true;
        this.pdfGeneratorService._getPDF(this.idTransaccion, this.PDF_REPORT_NAME).subscribe(
            response => {
                if (response.URLReporte) {
                    window.open(response.URLReporte, '_blank');
                }
                this.isPDFLoading = false;
            },
            ({error}) => {
                this.alertService.error(`Error al obtener el PDF: ${error?.message}`);
                goToTop();

                this.isPDFLoading = false;
            }
        )
    }

    generatePDF() {
        this.isPDFLoading = true;
        this.pdfGeneratorService._generatePDF(this.idTransaccion, this.PDF_REPORT_NAME, '', '', this.rut).subscribe(
            () => {
                this.getPDF();
            },
            ({error}) => {
                this.alertService.error(`Error al generar el PDF: ${error?.message}`);
                goToTop();

                this.isPDFLoading = false;
            }
        )
    }

}
